var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col items-center w-full gap-4 py-8",
      style: { minHeight: "calc(100vh - 2.5rem - 3.5rem - 5rem)" }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 px-10 py-10 w-152" },
        [
          _c(
            "div",
            { staticClass: "flex items-center justify-between" },
            [
              _c("BlTextSubtitle1", { attrs: { text: "Add tasks" } }),
              _vm._v(" "),
              !_vm.allTasksUsed
                ? _c("BlInputButton", {
                    attrs: { label: "Add new task" },
                    on: { clicked: _vm.onAddTasks }
                  })
                : _c(
                    "BlTooltip",
                    {
                      attrs: {
                        tooltip:
                          "You’ve reached the limit for tasks and can’t create a new one."
                      }
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { label: "Add new task", disabled: "" }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.sortedTasks, function(code, index) {
            return _c(
              "div",
              { key: "task-code-item-" + code.key },
              [
                _c("TasksCodesItem", {
                  attrs: {
                    kind: "client",
                    tasks: _vm.tasksCodes,
                    allTasksUsed: _vm.allTasksUsed,
                    defaultTasks: _vm.defaultTasks,
                    index: index,
                    code: code,
                    readOnly: !_vm.currentUser.role.includes("admin")
                  },
                  on: {
                    update: function($event) {
                      return _vm.$emit("updateTask", $event)
                    },
                    delete: function($event) {
                      return _vm.$emit("removeTask", $event)
                    }
                  }
                })
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex items-center w-full" }, [
            _c("div", {
              staticClass: "flex-grow h-1",
              class: _vm.allTasksUsed ? "bg-slate-400" : "bg-light-purple"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mx-4" }, [
              !_vm.allTasksUsed
                ? _c(
                    "div",
                    {},
                    [
                      _c("BlInputButton", {
                        attrs: { icon: "plus" },
                        on: { clicked: _vm.onAddTasks }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "p-1 rounded bg-slate-400" },
                    [
                      _c("BlIcon", {
                        staticClass: "w-6 h-6",
                        attrs: {
                          icon: "plus",
                          color: "grey",
                          tooltip:
                            "You’ve reached the limit for tasks and can’t create a new one."
                        }
                      })
                    ],
                    1
                  )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "flex-grow h-1",
              class: _vm.allTasksUsed ? "bg-slate-400" : "bg-light-purple"
            })
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b083d21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b083d21","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/overlay/NewTaskOverlay.vue
// module id = null
// module chunks = 